var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-panel',[_c('ui-line-chart',{staticClass:"chart",attrs:{"sets":_vm.chartSets,"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }